import { render, staticRenderFns } from "./ModalCareTeam.vue?vue&type=template&id=203bfc55&scoped=true"
import script from "./ModalCareTeam.vue?vue&type=script&lang=js"
export * from "./ModalCareTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203bfc55",
  null
  
)

export default component.exports